import { BaseEntity } from "../../baseEntity";

export class WorkGroup extends BaseEntity {

    protected readonly TITLE = "title";
    
    get title(): string { return this.getInternalValue<string>(this.TITLE); }
    setTitle(title: string): this { return this.setInternalValue(this.TITLE, title); }
}